import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import TitlePage from 'components/atoms/title-page'
import { PHASE3_PROCESS_STEPS } from '../constants'

const Phase3InboundDashboardPage = () => {
  return (
    <>
      <TitlePage mainTitle='Inbound Journey' subTitle='Overview' />

      <Card className='mb-3'>
        <CardBody>
          <h3 className='mb-2'>Inbound Journey V2</h3>
          <p className='text-muted mb-0'>
            New dashboard flow for receiving product, studio check, appraisal, price tag,
            live process, and outbound authentication after customer deal.
          </p>
        </CardBody>
      </Card>

      <Row>
        { PHASE3_PROCESS_STEPS.map((step) => (
          <Col md='6' xl='3' key={ step.number } className='mb-3'>
            <Card className='h-100'>
              <CardBody className='d-flex flex-column'>
                <div className='mb-2 text-muted'>Process #{ step.number }</div>
                <h4>{ step.title }</h4>
                <div className='small text-uppercase text-muted mb-2'>{ step.owner }</div>
                <p className='flex-grow-1'>{ step.description }</p>
                <Button tag={ Link } to={ step.route } color='primary' size='sm'>
                  Open
                </Button>
              </CardBody>
            </Card>
          </Col>
        )) }
      </Row>

      <Card>
        <CardBody>
          <h4>Print tools moved from website Ops pages</h4>
          <div className='d-flex flex-wrap' style={{ gap: 8 }}>
            <Button tag={ Link } to='/app/inbound-journey/price-tag-print' color='info'>
              Price Tag + Barcode Print
            </Button>
            <Button tag={ Link } to='/app/inbound-journey/invoice' color='info'>
              Invoice Print
            </Button>
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default Phase3InboundDashboardPage
